import React, { useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";


function Experience() {
  const [zoomedCard, setZoomedCard] = useState(null);

  const experiences = [
    {
      id: 1,
      company: "Static Int",
      position: "Full Stack Development Intern",
      duration: "6-week Internship",
      description:
        "Worked on the complete lifecycle of web application development, from designing responsive frontends using React.js to implementing secure backend APIs with Node.js and Express. Contributed to building real-time features, optimized database queries using MongoDB, and collaborated with cross-functional teams via GitHub. Gained exposure to Agile development and deployed applications on cloud platforms.",
      skills: ["React", "Node.js", "JavaScript", "Database Management"],
    },
    {
      id: 2,
      company: "Edu Tech",
      position: "Full Stack Development Intern",
      duration: "3-month Internship",
      description:
        "Built scalable education-based web modules using the MERN stack. Enhanced user interfaces for better student engagement, integrated REST APIs, and implemented secure user authentication flows. Improved performance through code refactoring and lazy loading. Participated in daily stand-ups, used Git for version control, and documented all major features developed during the internship.",
      skills: ["React", "Full Stack", "Web Development", "EdTech Solutions"],
    },
  ];

  const handleCardClick = (id) => {
    setZoomedCard(zoomedCard === id ? null : id);
  };

  return (
    <section
      style={{
       
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#ffffff",
        minHeight: "100vh",
        paddingTop: "60px",
        paddingBottom: "60px",
      }}
    >
      <Container>
        <h2 className="text-center mb-5" style={{ color: "#ffffff", fontWeight: "bold" }}>
          🚀 My Experience
        </h2>
        <Row className="justify-content-center">
          {experiences.map((exp) => (
            <Col key={exp.id} md={5} className="mb-4">
              <Card
                onClick={() => handleCardClick(exp.id)}
                className="h-100 shadow-lg experience-card hover-shadow"
                style={{
                  background: "#161629",
                  border: "2px solid #8b5cf6",
                  color: "#e0e0e0",
                  borderRadius: "20px",
                  cursor: "pointer",
                  transform: zoomedCard === exp.id ? "scale(1.05)" : "scale(1)",
                  transition: "transform 0.4s ease-in-out, box-shadow 0.3s ease-in-out",
                  boxShadow:
                    zoomedCard === exp.id
                      ? "0 0 25px rgba(139, 92, 246, 0.5)"
                      : "0 0 12px rgba(0, 0, 0, 0.2)",
                }}
              >

                <Card.Body>
                  
                  
                  <Card.Title style={{ fontSize: "4rem", fontWeight: "bold", color: "#8b5cf6" }}>
                    {exp.company}
                  </Card.Title>
                  <Card.Subtitle className="mb-3" style={{ color: "#87cefa" }}>
                    {exp.position}
                  </Card.Subtitle>
                  <Card.Text className="mb-3" style={{ lineHeight: "1.9", fontSize: "1.2rem" }}>
                    
                    {exp.description}
                  </Card.Text>
                  <div className="mb-2">
                    <strong style={{ color: "#8b5cf6" }}>Duration:</strong> {exp.duration}
                  </div>
                  <div>
                    <strong style={{ color: "#8b5cf6" }}>Skills:</strong>
                    <div className="mt-3 d-flex flex-wrap gap-3">
                      {exp.skills.map((skill, idx) => (
                        <Badge
                          bg="secondary"
                          key={idx}
                          style={{
                            background: "#8b5cf6",
                            color: "#8b5cf6",
                            fontWeight: "900",
                            fontSize: "1.2rem",
                            padding: "12px 20px",
                            borderRadius: "14px",
                            boxShadow: "0 0 8px rgba(34, 30, 255, 0.47)",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                          }}
                        >
                          {skill}
                        </Badge>
                      ))}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Experience;
